import React from "react";
import { useLocation } from "react-router-dom";
import { format } from "date-fns";

import ButtonAgendamiento from "./ButtonAgendamiento";

const AgentPs = () => {
  let location = useLocation();
  const { psychologist } = location.state;
  const { appointmentsAvailable = [] } = psychologist.data;

  return (
    <div>
      {appointmentsAvailable.map((res, index) =>
        res.avalible &&
        format(new Date(res.time), "yyyy-MM-dd") >
          format(new Date(), "yyyy-MM-dd") ? (
          <ButtonAgendamiento
            key={index}
            date={res.time}
            time={res.time.slice(11)}
            id={res.id}
          />
        ) : (
          <div></div>
        )
      )}
    </div>
  );
};

export default AgentPs;
